import { featuresCommon } from './featuresCommon';
import { FeaturesConfig } from '../config';

export const featuresStage: FeaturesConfig = {
  ...featuresCommon,
  baseURL: "https://b2b-app.stage-gcp.fena.co",
  environment: "stage",

  app: {
    ...featuresCommon.app,
    appName: "fena-b2b-app-1",
  },

  cloudConfig: {
    provider: "gcp",
    gcp: {
      projectId: "prj-workload-stage",
      region: "europe-west2",
      integrationStorageBucket: "fena-integrations-api-stage",
      toolkitStorageBucket: "fena-toolkit-backend-stage",
      pubsub: {
        idMapSyncTopic: "batch-job-apps-id-maps-file-sync",
        bulkSyncTopic: "batch-job-apps-bulk-sync",
      },
    },
  },

  sentry: {
    dsn: "https://c111932471c01fe011f96c16281764d7@o1222258.ingest.us.sentry.io/4510467298754560",
  },
};
